'use client'

import { Swiper, SwiperSlide } from 'swiper/react'
import {
   Pagination,
   Navigation,
   Autoplay,
   Keyboard,
   EffectCoverflow,
} from 'swiper/modules'

export default function ScreenShotSlider({ images }) {
   return (
      <>
         <section className="preview-images-section section_secondary_bg">
            <div className="mx-sm-5 mx-3 screenShot_slider screenShot_slider_wedding_shadow d-flex justify-content-center flex-column">
               <div className="slider-column">
                  <Swiper
                     modules={[
                        Navigation,
                        Pagination,
                        Autoplay,
                        Keyboard,
                        EffectCoverflow,
                     ]}
                     loop={true}
                     centeredSlides={true}
                     autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                     }}
                     speed={600}
                     grabCursor={true}
                     freeMode={false}
                     mousewheel={false}
                     keyboard={{ enabled: true }}
                     effect="coverflow"
                     slidesPerView={3}
                     pagination={{
                        el: '.custom-screenShot_slider-pagination',
                        dynamicBullets: false,
                        clickable: true,
                        renderBullet: (index, className) =>
                           `<span class="${className} custom-bullet"></span>`,
                     }}
                     navigation={{
                        nextEl: '.custom-screenShot_slider-next-btn',
                        prevEl: '.custom-screenShot_slider-prev-btn',
                     }}
                     breakpoints={{
                        320: { slidesPerView: 1, spaceBetween: 80 },
                        768: {
                           slidesPerView: 3,
                           spaceBetween: 30,
                           coverflowEffect: {
                              stretch: -20,
                           },
                        },
                        992: {
                           slidesPerView: 3,
                           spaceBetween: 22,
                           coverflowEffect: {
                              stretch: -30,
                           },
                        },
                        1200: {
                           slidesPerView: 3,
                           spaceBetween: 15,
                           coverflowEffect: {
                              stretch: -35,
                           },
                        },
                        1440: {
                           slidesPerView: 3,
                           spaceBetween: 22,
                           coverflowEffect: {
                              stretch: -40,
                           },
                        },
                        1600: {
                           slidesPerView: 3,
                           spaceBetween: 45,
                           coverflowEffect: {
                              stretch: -40,
                           },
                        },
                        1800: {
                           slidesPerView: 3,
                           spaceBetween: 21,
                           coverflowEffect: {
                              stretch: -55,
                           },
                        },
                        1950: {
                           slidesPerView: 3,
                           spaceBetween: 30,
                           coverflowEffect: {
                              stretch: -60,
                           },
                        },
                        2175: {
                           slidesPerView: 3,
                           spaceBetween: 40,
                           coverflowEffect: {
                              stretch: -70,
                           },
                        },
                        2500: {
                           slidesPerView: 3,
                           spaceBetween: 50,
                           coverflowEffect: {
                              stretch: -80,
                           },
                        },
                     }}
                     coverflowEffect={{
                        rotate: 0,
                        stretch: -25,
                        depth: 100,
                        modifier: 1,
                        slideShadows: false,
                     }}
                     className="custom-screenShot_slider"
                  >
                     {images.map((imageSrc, index) => (
                        <SwiperSlide key={index}>
                           <div className="screenShot_slider-card h-100 w-100">
                              <img
                                 className="h-100 w-100"
                                 src={imageSrc}
                                 alt={`Screenshot ${index + 1}`}
                              />
                           </div>
                        </SwiperSlide>
                     ))}

                     {/* Pagination & Navigation inside the slider container */}
                     <div className="d-flex justify-content-center">
                        <div className="d-flex align-items-center justify-content-center">
                           <span className="mt-4 d-flex align-items-center justify-content-center custom-screenShot_slider-pagination"></span>
                        </div>
                     </div>
                  </Swiper>
               </div>

               <button className="custom-screenShot_slider-prev-btn custom-prev-btn">
                  <div>
                     <img
                        src="/assets/svg/technologies/previous_icon.svg"
                        alt="prev"
                     />
                  </div>
               </button>
               <button className="custom-screenShot_slider-next-btn custom-next-btn">
                  <div>
                     <img
                        src="/assets/svg/technologies/next_icon.svg"
                        alt="prev"
                     />
                  </div>
               </button>
            </div>
         </section>
      </>
   )
}
